import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../common/loaderapp';
import Lightbox from "react-image-lightbox";
import 'react-image-lightbox/style.css';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Detalle = ({pag_actualizar,setPag_actualizar}) => {

    const [load, setLoad] = useState(false);
    const [datos, setDatos] = useState({});
	const [preview_img, setPreview_img] = useState({});
	const [look_archivos, setLook_archivos] = useState(false);

    useEffect(() => {
        if(pag_actualizar.SITIO != 'COMPROBANTE'){
            fetch('/p_pantografo', {
                headers: {'Content-Type': 'application/json'},
                method:'POST',
                body: JSON.stringify({ID:pag_actualizar.ID})
            })
            .then(res => res.json())
            .then(res =>{
                console.log('Detalle Pan: ',res);
                setDatos(res);
                setLoad(true)
            })
            .catch(err => console.log('Error: '+err))
        }
        else{
            fetch('/p_pantografo', {
                headers: {'Content-Type': 'application/json'},
                method:'PUT',
                body: JSON.stringify({ID:pag_actualizar.ID})
            })
            .then(res => res.json())
            .then(res =>{
                console.log(res);
                setDatos(res);
				setLoad(true)
            })
        }
    }, []);

	const descargarArchivos=()=>{
		setLook_archivos(true)
		var nombre_archivo

		fetch('/p_archivo_vacante_f', {
            headers:{'Content-Type': 'application/json'},
			method:'POST',
			body: JSON.stringify({ID:pag_actualizar.ID})
		})
        .then( res => res.json() )
        .then( res => {
            nombre_archivo=res.filename

			for (let index = 0; index < nombre_archivo.length; index++) {
				let numero=index
				fetch('/p_archivo_vacante', {
        		    headers:{'Content-Type': 'application/json'},
					method:'POST',
					body: JSON.stringify({ID:pag_actualizar.ID,pos:numero})
				})
        		.then( res => res.blob() )
        		.then( blob => {
        		    let file = window.URL.createObjectURL(blob);
        		    let a = document.createElement('a');
        		    a.href = file;
        		    a.download = `${nombre_archivo[numero]}`;
        		    document.body.appendChild(a);
        		    a.click();    
        		    a.remove(); 
					setLook_archivos(false)
        		});
				
			}
        });
	}

	const descargarArchivosCoti=(folio,id,nombre)=>{
		setLook_archivos(true)
		
		fetch('/p_archivo_cotizacion', {
            headers:{'Content-Type': 'application/json'},
			method:'POST',
			body: JSON.stringify({ID:id,FOLIO:folio,NOMBRE:nombre})
		})
        .then( res => res.blob() )
        .then( blob => {
            let file = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = file;
            a.download = `${nombre}`;
            document.body.appendChild(a);
            a.click();    	
            a.remove(); 
			setLook_archivos(false)
        });
	}

    return (
        <div className="container-fluid">
            {
				load ?
				<Fragment>
					<button className="btn btn-outline-primary-2x mb-3" onClick={()=> setPag_actualizar([])}>
                        <i className="icofont icofont-arrow-left"/>Regresar
                    </button>
					<div className="card">
						<div className="card-header">
							<div className="row">
								<h5 className="ml-4 font-weight-bold">Detalle del registro</h5>
								<h6 className="ml-2 text-right"><span className={`badge badge-info`}>{pag_actualizar.SITIO}</span></h6>
								<h5 className="ml-4 text-muted text-capitalize font-weight-light">Fecha registro: {pag_actualizar.FECHA}</h5>
							</div>
						</div>
						<div className="card-body">
						  	<div className="row">
                                {
                                    pag_actualizar.SITIO != 'COMPROBANTE' ?
                                    <Fragment>
                                        <div className="col-md-12">
								          	<div className="date-picker">
								        	  	<h2 className="text-center font-weight-bold mb-4">Datos de la cotización</h2>
								        		<form className="theme-form ml-5">
                                        
								        		  	<div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Nombres(s):</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.NOMBRE !='' ? datos.NOMBRE : '-' }</label>
								        		  	</div>
								        		  	<div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Apellidos:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.APELLIDOS !='' ? datos.APELLIDOS : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Correo electrónico:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.EMAIL !='' ? datos.EMAIL : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Teléfono:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.TELEFONO !='' ? datos.TELEFONO : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Estado:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.ESTADO !='' ? datos.ESTADO : '-'}</label>
								        		  	</div>
													  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Ciudad:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.CIUDAD !='' ? datos.CIUDAD : '-'}</label>
								        		  	</div>
													  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Base (cm):</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.BASE !='' ? datos.BASE : '-'}</label>
								        		  	</div> 
													  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Altura (cm):</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.ALTURA !='' ? datos.ALTURA : '-'}</label>
								        		  	</div> 
													  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Mensaje:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.MENSAJE !='' ? datos.MENSAJE : '-'}</label>
								        		  	</div> 
                                                    <div className="row d-flex justify-content-around">
														<button type="button" className="col-sm-3 btn btn-outline-primary pl-2 pr-2" onClick={descargarArchivos} disabled={look_archivos}>Descargar Archivo</button>
										  			</div>
								        		</form>
								          	</div>
								        </div>
                                    </Fragment> 
                                    :
                                    <Fragment>
                                        <div className="col-md-12">
								          	<div className="date-picker">
								        	  	<h2 className="text-center font-weight-bold mb-4">Datos del comprobante</h2>
								        		<form className="theme-form ml-5">
                                        
								        		  	<div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">NUM. COMPROBANTE:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.NUMERO_COMPROBANTE !='' ? datos.NUMERO_COMPROBANTE : '-' }</label>
								        		  	</div>
                                                    <div className="row d-flex justify-content-around">
														<button type="button" className="col-sm-3 btn btn-outline-primary pl-2 pr-2" onClick={descargarArchivosCoti} disabled={look_archivos}>Descargar Archivo</button>
										  			</div>
								        		</form>
								          	</div>
								        </div>									
                                    </Fragment>
                                }
						  	</div>
						</div>
		  			</div>
				</Fragment>
				: <Loader/>
			}
        </div>
    );
}
 
export default Detalle;
